// ShellXL - Sprint 44 XL.
// Contenedor del layout XL: grid con SidebarXL a la izquierda, TopbarXL
// arriba y main area debajo. Coexiste con MainLayout legacy: las vistas
// legacy siguen usando MainLayout; las vistas XL se van envolviendo con
// ShellXL a medida que se migran (Fase 3).
//
// Incluye <GlobalLoading /> global para que toda la app lo aproveche al
// pasar al shell XL.
//
// Uso:
//   <ShellXL title="Ventas" breadcrumbs={[{label:'Dashboard',to:'/'}, {label:'Ventas'}]}>
//     <MiVistaXL />
//   </ShellXL>
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../design/motion';
import { useXLTheme } from '../../design/tokens';
import SidebarXL from './SidebarXL';
import TopbarXL from './TopbarXL';
import GlobalLoading from '../../branding/GlobalLoading';

const CSS_ID = 'xl-shell-css';
const CSS = `
.xl-shell {
  display: grid;
  grid-template-columns: 260px 1fr;
  grid-template-rows: auto 1fr;
  grid-template-areas:
    "side top"
    "side main";
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background: var(--xl-color-surface-alt);
  color: var(--xl-color-text);
  font-family: var(--xl-font-sans);
}
.xl-shell__side { grid-area: side; min-width: 0 }
.xl-shell__top  { grid-area: top;  min-width: 0 }
.xl-shell__main {
  grid-area: main;
  min-width: 0;
  overflow: auto;
  background: var(--xl-color-surface-alt);
}
@media (max-width: 900px) {
  .xl-shell {
    grid-template-columns: 1fr;
    grid-template-areas:
      "top"
      "main";
  }
  .xl-shell__side { display: none }
}
`;

export default function ShellXL({ children, title, breadcrumbs }) {
  useEffect(() => {
    ensureKeyframes();
    injectCSS(CSS_ID, CSS);
  }, []);

  // Asegurar que el tema se aplica al montar (CSS vars en :root).
  useXLTheme();

  return (
    <div className="xl-shell">
      <GlobalLoading />
      <div className="xl-shell__side">
        <SidebarXL />
      </div>
      <div className="xl-shell__top">
        <TopbarXL title={title} breadcrumbs={breadcrumbs} />
      </div>
      <main className="xl-shell__main" id="xl-main-content" tabIndex={-1}>
        {children}
      </main>
    </div>
  );
}
